import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { hasPositiveValue } from '@packages/shared/core/common/utils/hasPositiveValue';
import { CrossDomainStorage, HttpClient } from '@packages/shared/core/common/services';
import { ApiPathAskGateway } from '@packages/shared/core/common/constants/apiPaths';
import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { FeatureFlags } from '@packages/shared/core/feature-flags/services';

export class BackendAnalyticsService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly crossDomainStorage: CrossDomainStorage,
    private readonly featureFlags: FeatureFlags,
    private readonly logger: Logger,
  ) {}

  async setSplitExperimentProperties(props: { experimentName: string; groupName: string }) {
    const { experimentName, groupName } = props;
    const tests = [{ name: experimentName, group: groupName }];

    try {
      const rawUserId = this.crossDomainStorage.getNebulaId();
      const userId = rawUserId != null ? Number(rawUserId) : null;

      if (rawUserId != null && !hasPositiveValue(userId)) {
        this.logger.warn('BackendAnalyticsService.setSplitExperimentProperties: nebula_id present but invalid', {
          data: { rawUserId },
        });
      }

      if (hasPositiveValue(userId)) {
        await this.httpClient.post<{ result: boolean }>(ApiPathAskGateway.SPLIT_TESTS_BY_USER_ID, {
          data: {
            user_id: userId,
            tests,
          },
        });
        return;
      }

      const splitId = this.featureFlags.getSplitId();

      if (!splitId) {
        this.logger.warn('BackendAnalyticsService.setSplitExperimentProperties: no userId or splitId available');
        return;
      }

      await this.httpClient.post<{ result: boolean }>(ApiPathAskGateway.SPLIT_TESTS_BY_SPLIT_ID, {
        data: {
          split_id: splitId,
          tests,
        },
      });
    } catch (e) {
      const err = normalizeError(e);
      this.logger.error(err);
    }
  }
}
